import request from 'superagent';
import superagentPromisePlugin from 'superagent-promise-plugin';
import { config, HEADER_STORE_CODE } from '../config/config';
import moment from 'moment';
import authUtils from '../script/utils/commons';
import { i18n_get_value, I18N_LABELS } from '../i18n/i18n_scripts';
import { reduxStore } from '../index';
import { updatedScheduledOrders } from '../app/data/actions/scheduled'


const now = Date.now();

function getMock(mockDelay) {

    if (!mockDelay) {
        mockDelay = 500;
    }

    return new Promise(resolve => {
        setTimeout(() => resolve({
            id: 106,
            name: 'DeliveryTracker',
            lat: 41.155223,
            lng: -8.630050,
            avgPreparationTime: (7.399 + Math.random() * 3) * 60,
            avgDispatchTime: (3 + Math.random() * 3) * 60,
            avgStoreTime: (7.399 + Math.random() * 3) * 60,
            avgDrivingTime: (15.299 + Math.random() * 3) * 60,
            avgDeliveryTime: (22.689 + Math.random() * 3) * 60,
            expectedDeliveryTime: (30 + Math.ceil(Math.random() * 5) * 5),
            avgRating: (Math.random() * 4) + 1,
            drivers: [
                {
                    id: 29,
                    name: i18n_get_value(I18N_LABELS.MOCK_DRIVER_01_NAME),
                    status: 'free',
                    coordinates: { lat: 41.155223 + (Math.random() / 500), lng: -8.630050 + (Math.random() / 500) },
                    currentRunOrders: 0,
                    currentRunClosedOrders: 0,
                    updatedAt: moment(now).toISOString(),
                }, {
                    id: 28,
                    name: i18n_get_value(I18N_LABELS.MOCK_DRIVER_02_NAME),
                    status: 'free',
                    coordinates: { lat: 41.155223 + (Math.random() / 500), lng: -8.630050 + (Math.random() / 500) },
                    updatedAt: moment(now).toISOString(),
                }, {
                    id: 30,
                    name: i18n_get_value(I18N_LABELS.MOCK_DRIVER_03_NAME),
                    status: 'busy',
                    coordinates: { lat: 41.1652606 + (Math.random() / 50), lng: -8.6115705 + (Math.random() / 50) },
                    currentRunOrders: 2,
                    currentRunClosedOrders: 1,
                    updatedAt: moment(now).toISOString(),
                }, {
                    id: 31,
                    name: i18n_get_value(I18N_LABELS.MOCK_DRIVER_04_NAME),
                    status: 'busy',
                    updatedAt: moment(now).toISOString(),
                    coordinates: { lat: 41.1600606 + (Math.random() / 50), lng: -8.6195705 + (Math.random() / 50) },
                    currentRunOrders: 2,
                    currentRunClosedOrders: 0,
                }, {
                    id: 32,
                    name: i18n_get_value(I18N_LABELS.MOCK_DRIVER_05_NAME),
                    status: 'busy',
                    coordinates: { lat: 41.1562606 + (Math.random() / 50), lng: -8.6015705 + (Math.random() / 50) },
                    currentRunOrders: 5,
                    currentRunClosedOrders: 2,
                    updatedAt: moment(now).toISOString(),
                }, {
                    id: 33,
                    name: i18n_get_value(I18N_LABELS.MOCK_DRIVER_06_NAME),
                    status: 'busy',
                    coordinates: { lat: 41.1562606 + (Math.random() / 50), lng: -8.6505705 + (Math.random() / 50) },
                    currentRunOrders: 5,
                    currentRunClosedOrders: 3,
                    updatedAt: moment(now).toISOString(),
                }, {
                    id: 34,
                    name: i18n_get_value(I18N_LABELS.MOCK_DRIVER_07_NAME),
                    status: 'busy',
                    coordinates: { lat: 41.1642606 + (Math.random() / 50), lng: -8.6465705 + (Math.random() / 50) },
                    currentRunOrders: 5,
                    currentRunClosedOrders: 4,
                    updatedAt: moment(now).toISOString(),
                }, {
                    id: 35,
                    name: i18n_get_value(I18N_LABELS.MOCK_DRIVER_08_NAME),
                    status: 'returning',
                    coordinates: { lat: 41.155223 + (Math.random() / 50), lng: -8.631050 + (Math.random() / 50) },
                    currentRunOrders: 3,
                    currentRunClosedOrders: 3,
                    _returningInfo: { duration: Math.trunc(Math.random() * 1000000), distance: 5347 },
                    updatedAt: moment(now).toISOString()
                }, {
                    id: 36,
                    name: i18n_get_value(I18N_LABELS.MOCK_DRIVER_09_NAME),
                    status: 'returning',
                    coordinates: { lat: 41.1452606 + (Math.random() / 50), lng: -8.6015705 + (Math.random() / 50) },
                    currentRunOrders: 2,
                    currentRunClosedOrders: 2,
                    _returningInfo: { duration: Math.trunc(Math.random() * 1000000), distance: 6247 },
                    updatedAt: moment(now).toISOString()
                }
            ],
            orders: [
                {
                    id: 141771,
                    code: 277,
                    customerName: 'DANIEL ANTAS',
                    customerPhone: '913081573',
                    address: 'Rua Círiaco Cardoso 123 Porto Andar 5 Direito Frente',
                    city: 'PORTO',
                    postalCode: '4150-211 PORTO',
                    addressObs: null,
                    total: 33.45,
                    notes: null,
                    deliveryDate: moment(now + 30 * 60e3).toISOString(),
                    status: 'delivering',
                    rating: null,
                    maximumSpeed: null,
                    returnReason: null,
                    createdAt: moment(now - 27 * 60e3).toISOString(),
                    updatedAt: moment(now).toISOString(),
                    driverId: 30
                },
                {
                    id: 417722,
                    code: 277,
                    customerName: 'DANIEL Martinho',
                    customerPhone: '913081573',
                    address: 'RUA CALOUSTE GULBENKIAN 17 5ºANDAR',
                    city: 'PORTO',
                    postalCode: '4050-145 PORTO',
                    addressObs: null,
                    total: 23.45,
                    notes: null,
                    deliveryDate: moment(now + 35 * 60e3).toISOString(),
                    status: 'delivering',
                    rating: null,
                    maximumSpeed: null,
                    returnReason: null,
                    createdAt: moment(now - 17 * 60e3).toISOString(),
                    updatedAt: moment(now).toISOString(),
                    driverId: 34
                },
                {
                    id: 417733,
                    code: 277,
                    customerName: 'DANIEL ANTAS',
                    customerPhone: '913081573',
                    address: 'R. Feliciano de Castilho 211',
                    city: 'PORTO',
                    postalCode: '4150-312 PORTO',
                    addressObs: null,
                    total: 43.45,
                    notes: null,
                    deliveryDate: moment(now + 40 * 60e3).toISOString(),
                    status: 'assigned',
                    rating: null,
                    maximumSpeed: null,
                    returnReason: null,
                    createdAt: moment(now - 7 * 60e3).toISOString(),
                    updatedAt: moment(now).toISOString(),
                },
                {
                    id: 417744,
                    code: 277,
                    customerName: 'DANIEL ANTAS',
                    customerPhone: '913081573',
                    address: 'Rua da Alegria',
                    city: 'PORTO',
                    postalCode: '4000-099 PORTO',
                    addressObs: null,
                    total: 13.45,
                    notes: null,
                    deliveryDate: moment(now + 17 * 60e3).toISOString(),
                    status: 'assigned',
                    rating: null,
                    maximumSpeed: null,
                    returnReason: null,
                    createdAt: moment(now - 37 * 60e3).toISOString(),
                    updatedAt: moment(now).toISOString(),
                    driverId: 32
                },
                {
                    id: 417745,
                    code: 277,
                    customerName: 'DANIEL ANTAS',
                    customerPhone: '913081573',
                    address: 'Rua da Constituição',
                    city: 'PORTO',
                    postalCode: '4250-162 PORTO',
                    addressObs: null,
                    total: 13.45,
                    notes: null,
                    deliveryDate: moment(now + 19 * 60e3).toISOString(),
                    status: 'created',
                    rating: null,
                    maximumSpeed: null,
                    returnReason: null,
                    createdAt: moment(now - 37 * 60e3).toISOString(),
                    updatedAt: moment(now).toISOString(),
                    driverId: 31
                },
                {
                    id: 417746,
                    code: 377,
                    customerName: 'DANIEL ANTAS',
                    customerPhone: '913081573',
                    address: 'Rua da Quinta Amarela Nº 87',
                    city: 'PORTO',
                    postalCode: '4050-277 PORTO',
                    addressObs: null,
                    total: 13.45,
                    notes: null,
                    deliveryDate: moment(now + 22 * 60e3).toISOString(),
                    status: 'created',
                    rating: null,
                    maximumSpeed: null,
                    returnReason: null,
                    createdAt: moment(now - 37 * 60e3).toISOString(),
                    updatedAt: moment(now).toISOString(),
                    driverId: 33
                },
            ],
            alarms: [
                //    {
                //    id: 234567,
                //    driverId: 45422,
                //    driverName: 'Teste Driver',
                //    status: 'OPEN',
                //    location: {lat: 41.166020, lng: -8.626776},
                // }
            ],
            scheduled: [
                {
                    id: 56973509924,
                    customerName: 'DANIEL ANTAS',
                    customerPhone: '913081573',
                    address: 'Rua da Alegria',
                    city: 'PORTO',
                    postalCode: '4150-800 PORTO',
                    total: 44.6,
                    addressObs: "",
                    deliveryDate: moment(now).add(60, 'm').toDate().toISOString(),
                    status: "CREATED",
                    dispatchStatus: "scheduled",
                    createdAt: moment(now - 3 * 60e3).toISOString(),
                    updatedAt: moment(now).toISOString(),
                },
                {
                    id: 56973509927,
                    customerName: 'DANIEL ANTAS',
                    customerPhone: '913081573',
                    address: 'Rua da Alegria',
                    city: 'PORTO',
                    postalCode: '4150-800 PORTO',
                    total: 44.6,
                    addressObs: "",
                    deliveryDate: moment(now).add(65, 'm').toDate().toISOString(),
                    status: "CREATED",
                    dispatchStatus: "scheduled",
                    createdAt: moment(now - 3 * 60e3).toISOString(),
                    updatedAt: moment(now).toISOString(),
                },
                {
                    id: 56973509922,
                    customerName: "**TESTE**",
                    customerPhone: "222222222",
                    address: "Rua 5 de Outubro Second Part address",
                    city: "Porto",
                    total: 23.5,
                    postalCode: "4150-626 PORTO",
                    addressObs: "",
                    deliveryDate: moment(now).add(50, 'm').toDate().toISOString(),
                    status: "CREATED",
                    dispatchStatus: "scheduled",
                    createdAt: moment(now - 1 * 60e3).toISOString(),
                    updatedAt: moment(now).toISOString(),
                },
                {
                    id: 56973509938,
                    customerName: 'DANIEL ANTAS',
                    customerPhone: '913081573',
                    address: 'Rua da Alegria',
                    city: 'PORTO',
                    postalCode: '4150-800 PORTO',
                    total: 44.6,
                    addressObs: "",
                    deliveryDate: moment(now).add(70, 'm').toDate().toISOString(),
                    status: "CREATED",
                    dispatchStatus: "scheduled",
                    createdAt: moment(now - 3 * 60e3).toISOString(),
                    updatedAt: moment(now).toISOString(),
                },
                {
                    id: 56973509941,
                    customerName: 'DANIEL ANTAS',
                    customerPhone: '913081573',
                    address: 'Rua da Alegria',
                    city: 'PORTO',
                    postalCode: '4150-800 PORTO',
                    total: 44.6,
                    addressObs: "",
                    deliveryDate: moment(now).add(80, 'm').toDate().toISOString(),
                    status: "CREATED",
                    dispatchStatus: "scheduled",
                    createdAt: moment(now - 3 * 60e3).toISOString(),
                    updatedAt: moment(now).toISOString(),
                },
                {
                    id: 56973509923,
                    customerName: 'DANIEL Martinho',
                    customerPhone: '913081573',
                    address: 'RUA CALOUSTE GULBENKIAN 17 5ºANDAR',
                    city: 'PORTO',
                    postalCode: '4050-145 PORTO',
                    total: 12.9,
                    addressObs: "",
                    deliveryDate: moment(now).add(55, 'm').toDate().toISOString(),
                    status: "CREATED",
                    dispatchStatus: "scheduled",
                    createdAt: moment(now - 2 * 60e3).toISOString(),
                    updatedAt: moment(now).toISOString(),
                },
            ],
        }), mockDelay)
    });


}

const customError = {
    "original": null,
    "response": {
        "req": {
            "method": "POST",
            "url": "https://deliverytracker-tst-api.factsandit.mindera.com/login",
            "data": "user=delivery&store_id=248&ts=1552504360&md5=eea062cbe1fe231d9432a82cba17b38c",
            "headers": {
                "x-store-code": "248",
                "content-type": "application/x-www-form-urlencoded"
            }
        },
        "xhr": {
        },
        "text": "",
        "statusText": "",
        "statusCode": 401,
        "status": 401,
        "statusType": 4,
        "info": false,
        "ok": false,
        "redirect": false,
        "clientError": true,
        "serverError": false,
        "error": {
            "status": 401,
            "method": "POST",
            "url": "https://deliverytracker-tst-api.factsandit.mindera.com/login"
        },
        "created": false,
        "accepted": false,
        "noContent": false,
        "badRequest": false,
        "unauthorized": true,
        "notAcceptable": false,
        "forbidden": false,
        "notFound": false,
        "unprocessableEntity": false,
        "headers": {
            "cache-control": "no-cache, no-store, max-age=0, must-revalidate",
            "content-length": "0",
            "expires": "0",
            "pragma": "no-cache",
            "content-type": null
        },
        "header": {
            "cache-control": "no-cache, no-store, max-age=0, must-revalidate",
            "content-length": "0",
            "expires": "0",
            "pragma": "no-cache",
            "content-type": null
        },
        "type": "",
        "links": {
        },
        "body": null
    },
    "status": 401
};


var counter = 0
function getStoreInfo(storeId, params) {

    if (config.mock && config.mock === true) {
        console.debug("getStoreInfo: Using mock data")
        counter = (counter + 1) % 5;
        if (counter === 0) {
            return new Promise((resolve, reject) => reject(customError));
        }
        return getMock();
    }


    console.debug("Requesting data for store: " + storeId + "(" + JSON.stringify(params) + ")");

    return request.get(`${config.apiUrl}/v1/stores/${storeId}/info`)
        .withCredentials()
        .query(params)
        .set('Accept', 'application/json')
        .set(HEADER_STORE_CODE, storeId)
        .use(superagentPromisePlugin)
        .then(res => res.body)
        .catch(err => {
            console.error(err);
            throw err;
        });
}

function getOpenOrders(params) {

    const storeId = authUtils.getLoginStoreId();

    return request.get(`${config.apiUrl}/v1/stores/${params.storeId}/open-orders`)
        .withCredentials()
        .set('Accept', 'application/json')
        .set(HEADER_STORE_CODE, storeId)
        .use(superagentPromisePlugin)
        .then(res => res.body)
        .catch(err => {
            console.error(err);
            throw err;
        });
}

function closeDriverAlarm(alarm) {
    const storeId = authUtils.getLoginStoreId();

    return request.put(`${config.apiUrl}/v1/alarms/${alarm.id}/close`)
        .withCredentials()
        .set('Content-Type', 'application/json')
        .set(HEADER_STORE_CODE, storeId)
        .use(superagentPromisePlugin)
        .then(res => res.body)
        .catch(err => {
            console.error(err);
            throw err;
        });
}


function fastForwardScheduledOrder(orders) {


    // Make sure is its and array
    orders = (Array.isArray(orders) ? orders : [orders]);

    if (config.mock && config.mock === true) {
        getMock(4000).then(res => {
            console.log("Mock Response from server........")
            let updatedOrders = [];
            res.scheduled.forEach(order => {
                for (let i = 0; i < orders.length; ++i) {
                    if (orders[i] === order.id) {
                        let tmp = Object.assign({}, order);
                        tmp.dispatchStatus = "dispatched";
                        updatedOrders.push(tmp);
                    }
                }

            });

            console.log("-----> " + JSON.stringify(updatedOrders));
            reduxStore.dispatch(updatedScheduledOrders(updatedOrders, orders))
        });

        return;
    }

    const storeId = authUtils.getLoginStoreId();

    return request.post(`${config.apiUrl}/v1/orders/scheduled/dispatch`)
        .withCredentials()
        .send(orders)
        .set('Accept', 'application/json')
        .set('Content-Type', 'application/json')
        .set(HEADER_STORE_CODE, storeId)
        .use(superagentPromisePlugin)
        .then(res => reduxStore.dispatch(updatedScheduledOrders(res.body, orders)))
        .catch(err => {
            reduxStore.dispatch(updatedScheduledOrders(orders, orders))
            console.error(err);
            throw err;
        });
}


export default {
    getStoreInfo,
    getOpenOrders,
    closeDriverAlarm,
    fastForwardScheduledOrder,
};
